import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { getExciseWarehouseTableColumns } from "../../../../modules/obligee/exciseWarehouse/exciseWarehouse.constants";
import { ExciseWarehouseContext } from "../../../../modules/obligee/exciseWarehouse/exciseWarehouse.context";
import { useExciseWarehouseRequestList } from "../../../../modules/obligee/exciseWarehouse/exciseWarehouse.queries";
import { ExciseWarehouse } from "../../../../modules/obligee/exciseWarehouse/exciseWarehouse.types";

export const ExciseWarehouseList = () => {
  const { setExciseWarehouse } = useContext(ExciseWarehouseContext);

  const navigate = useNavigate();

  const onTableRowClickHandler = (record: ExciseWarehouse) => {
    setExciseWarehouse({ selectedWarehouseId: record.skladisteId });
    navigate(`/obveznik/skladista/zahtev?id=${record.skladisteId}`);
  };

  return (
    <FilterableTableLayout<ExciseWarehouse>
      tableRowKey="skladisteId"
      tableName="excise_warehouse_table"
      toolbarId="excise_warehouse_list"
      title={t("SKLADISTA.LISTA_SKLADISTA")}
      getTableColumns={getExciseWarehouseTableColumns}
      queryHook={useExciseWarehouseRequestList as any}
      onTableRowClick={onTableRowClickHandler}
    />
  );
};
